export const opportunitiesData = [
  {
    id: 1,
    title: "Agribusiness Officer",
    company: "Farm Radio Holdings Limited (FHL)",
    location: "Lilongwe",
    type: "Career",
    subType: "Full-time",
    duration: "1-year contract, renewable",
    applicationDeadline: "2025-10-03",
    postedDate: "2025-09-15",
    category: "Agriculture",
    salary: "Competitive package",
    donor: "FRT",
    donorLogo: "/images/logo.png",
    logoa: "/images/logoa.png",
    background: "Farm Radio Holdings Limited (FHL) is a private limited company, which is a subsidiary of Farm Radio Trust (FRT)...",
    purpose: "The Agribusiness Officer will be responsible for overseeing the planning, implementation, and monitoring of all agribusiness activities...",
    responsibilities: [
      {
        category: "Agribusiness Development",
        tasks: [
          "Design the sustainable youth agribusiness fund as a revolving initiative.",
          "Identify, engage, and support youth farmers and youth-led agribusinesses.",
          "Assess business viability and capacity of youth applicants for the input support.",
          "Provide technical support in farm business planning, budgeting, and enterprise development."
        ]
      }
    ],
    qualifications: [
      "Bachelor's degree in Agribusiness, Agriculture Economics, Agronomy, or related field.",
      "At least 5-8 years of experience in agribusiness development or agricultural finance."
    ],
    applicationProcess: "Qualified and interested individuals should submit their CV and cover letter to info@farmradiomw.org with the subject line \"Application: Agribusiness Officer\" by 3rd October 2025"
  },
  {
    id: 2,
    title: "Undertake multi media awareness campaign for Mlimi App",
    company: "Farm Radio Trust (FRT)",
    location: "Lilongwe, Malawi",
    type: "Consultancy",
    subType: "Terms of Reference (TOR)",
    duration: "3 Months",
    applicationDeadline: "2025-09-20",
    postedDate: "2025-08-25",
    category: "Communication",
    donor: "Government of Flanders",
    donorLogo: "/images/donors/flanders.jpg",
    logoa: "/images/logoa.png",
    introduction: "Farm Radio Trust (FRT) is a leading non- governmental organization dedicated exclusively to serving smallholder communities through the provision of ICT based information, communication, extension and advisory services in Malawi...",
    contentScope: "Information and communication technology in agriculture (ICT in agriculture), also known as e-agriculture, focuses on the enhancement of agricultural and rural development through improved information and communication processes...",
    objectives: "The objective of the assignment is to monitor, maintain and upgrade server system for FRT and ensure safety, scalability and accessibility to support all digital platforms: call center, databases and MaCOP.",
    keyTasks: [
      "Develop a multi media campaign to raise awareness of mlimi app among farmers, private sector, non-governmental organizations and government stakeholders",
      "Implement the multi media campaign to raise awareness of mlimi app",
      "Track subscription of users of the mlimi app",
      "Develop a multi media campaign"
    ],
    deliverables: [
      "An inception report outlining the multimedia campaign.",
      "Draft multimedia campaign report",
      "A final multimedia campaign report"
    ],
    timeFrame: "This assignment shall be conducted in no more than three months period.",
    qualifications: [
      "A minimum of bachelor’s degree in communication, journalism , development studies etc.",
      "At least 5 years’ experience in conducting multimedia campaign."
    ],
    applicationProcess: "Interested Consultant/s may submit an EOI electronically and CVs by 20th September 2025. For more information contact the undersigned.\n\nDirector of Programs\nFarm Radio Trust\ninfo@farmradiomw.org\n\nSubmission should be made through:\nFarm Radio Trust Offices\nArea 47 Sector 4\nOff Msokela Road, (from Bwandilo)\nMazengera Street, Plot number 862\nP.O Box 30081, Lilongwe 3"
  },
  {
    id: 3,
    title: "Undertake digital awareness session with community ICT hubs",
    company: "Farm Radio Trust (FRT)",
    location: "Lilongwe, Malawi",
    type: "Consultancy",
    subType: "Terms of Reference (TOR)",
    duration: "4 Months",
    applicationDeadline: "2025-09-15",
    postedDate: "2025-08-01",
    category: "Extension & ICT",
    donor: "Government of Flanders",
    donorLogo: "/images/donors/flanders.jpg",
    logoa: "/images/logoa.png",
    introduction: "Farm Radio Trust (FRT) is a leading non- governmental organization dedicated exclusively to serving smallholder communities through the provision of ICT based information, communication, extension and advisory services in Malawi...",
    contentScope: "Information and communication technology in agriculture (ICT in agriculture), also known as e-agriculture, focuses on the enhancement of agricultural and rural development through improved information and communication processes. With the challenges facing the provision of face-to-face extension, a number of actors have devised mechanism of employing ICTs in complementing face to face extension. This has resulted in mushrooming of ICT platforms and services in agriculture. Farm Radio Trust would like to upscale the uptake of ICTs to access and utilize engagement in the agriculture sector. FRT requests expressions of interest from capacity building experts to train and raise digital awareness among the farming communities in the ICT hubs.",
    objectives: "The objective of the assignment is to undertake digital awareness sessions with impact ICT hubs among the farming communities.",
    keyTasks: [
      "Develop and consolidate bundled digital platforms for farmers especially developed by Farm Radio Trust",
      "Develop tools for training the ICT hubs.",
      "Facilitate training sessions with impact ICT hubs based on guidance from FRT.",
      "Consolidate details of the farmers enrolled in the digital platforms.",
      "Compile a final training report with clear recommendations for the future."
    ],
    deliverables: [
      "An inception report outlining the process for the assignment",
      "A final training report with clear recommendations"
    ],
    timeFrame: "This assignment shall be conducted in no more than 4 months period.",
    qualifications: [
      "A minimum of master’s degree in agriculture Extension and Rural Development or related discipline e.g. ICTs, Communication, Development Studies",
      "At least 5 years’ experience in conducting training sessions with farmers.",
      "Understanding of the media and ICT landscape and how it relates to agricultural extension and advisory services is a must."
    ],
    applicationProcess: "Interested Consultant/s may submit an EOI electronically and CVs by 15th September 2025. For more information contact the undersigned.\n\nDirector of Programs\nFarm Radio Trust\ninfo@farmradiomw.org\n\nSubmission should be made through:\nFarm Radio Trust Offices\nArea 47 Sector 4\nOff Msokela Road, (from Bwandilo)\nMazengera Street, Plot number 862\nP.O Box 30081, Lilongwe 3"
  },
  {
    id: 4,
    title: "Server monitoring and maintenance develop interoperability of digital platforms",
    company: "Farm Radio Trust (FRT)",
    location: "Lilongwe, Malawi",
    type: "Consultancy",
    subType: "Terms of Reference (TOR)",
    duration: "3 Months",
    applicationDeadline: "2025-09-25",
    postedDate: "2025-08-15",
    category: "IT & Systems",
    donor: "Government of Flanders",
    donorLogo: "/images/donors/flanders.jpg",
    logoa: "/images/logoa.png",
    introduction: "Farm Radio Trust (FRT) is a leading non- governmental organization dedicated exclusively to serving smallholder communities through the provision of ICT based information, communication, extension and advisory services in Malawi...",
    contentScope: "Farm Radio Trust would like to upscale the uptake of ICTs to access and utilize engagement in the agriculture sector to improve farming households’ livelihoods. FRT is looking for a consultant to review server requirement to upgrade the requirements of the current CMS with the ability maintain interoperability with the multiple channels like IVR, radio, text, mobile apps etc.",
    objectives: "The objective of the assignment is to monitor, maintain and upgrade server system for FRT and ensure safety, scalability and accessibility to support all digital platforms: call center, databases and MaCOP.",
    keyTasks: [
      "Monitor the current server systems with existing digital solutions: call center, IVR, MaCOP, Mlimi App, mlimi radio etc.",
      "Troubleshot and fix the server operations.",
      "Assess the interoperability of the FRT digital platforms.",
      "Upgrade the server to accommodate current digital platforms with room for expansion.",
      "Ensure safety of the server and make recommendations to Management.",
      "Provide back up support for a minimum after six months"
    ],
    deliverables: [
      "An inception report outlining the process of the assignment.",
      "Assessment report on interoperability of digital platforms",
      "A final assignment reports."
    ],
    timeFrame: "This assignment shall be conducted in no more than three months period.",
    qualifications: [
      "A minimum of bachelor’s degree in ICTs, Software development , Computer Science etc.",
      "At least 5 years’ experience in ICT system review"
    ],
    applicationProcess: "Interested Consultant/s may submit an EOI electronically and CVs by 25th September 2025. For more information contact the undersigned.\n\nDirector of Programs\nFarm Radio Trust\ninfo@farmradiomw.org\n\nSubmission should be made through:\nFarm Radio Trust Offices\nArea 47 Sector 4\nOff Msokela Road, (from Bwandilo)\nMazengera Street, Plot number 862\nP.O Box 30081, Lilongwe 3"
  },
  {
    id: 5,
    title: "Translation of agri content into Chichewa and Tumbuka products",
    company: "Farm Radio Trust (FRT)",
    location: "Lilongwe, Malawi",
    type: "Consultancy",
    subType: "Terms of Reference (TOR)",
    duration: "2 Months",
    applicationDeadline: "2025-10-01",
    postedDate: "2025-08-01",
    category: "Languages & Content",
    donor: "Government of Flanders",
    donorLogo: "/images/donors/flanders.jpg",
    logoa: "/images/logoa.png",
    introduction: "Farm Radio Trust (FRT) is a leading non- governmental organization dedicated exclusively to serving smallholder communities through the provision of ICT based information, communication, extension and advisory services in Malawi...",
    contentScope: "Farm Radio Trust has developed extension content to be used by farmers to increase technology adoption. Most of the content is in English version and there is need to translate the content into local languages of Chichewa and Tumbuka. FRT requests expressions of interest from Language experts to undertake translation of the agri content into two local languages of Chichewa and Tumbuka.",
    objectives: "The objective of the assignment is to undertake translation of agri content into local languages of Chichewa and Tumbuka.",
    keyTasks: [
      "Review the agri content for selected value chains: soybean, groundnuts, Maize, livestock and emerging good agricultural practices and technologies.",
      "Develop a product list of the IEC materials and content to be translated into Chichewa and Tumbuka",
      "Conduct agri content translation into Chichewa and Tumbuka for selected value chains and technology"
    ],
    deliverables: [
      "An inception report outlining the process of language translation.",
      "Draft translation of agri content of selected technology and value chains.",
      "Final approved translation of agri content."
    ],
    timeFrame: "This assignment shall be conducted in no more than 2 months period.",
    qualifications: [
      "A bachelor’s degree in communications, languages, Development studies, Agriculture, Community Development",
      "Understanding of local languages",
      "At least 3 years’ experience in conducting language translation of development materials."
    ],
    applicationProcess: "Interested Consultant/s may submit an EOI electronically and CVs by 1st October 2025. For more information contact the undersigned.\n\nDirector of Programs\nFarm Radio Trust\ninfo@farmradiomw.org\n\nSubmission should be made through:\nFarm Radio Trust Offices\nArea 47 Sector 4\nOff Msokela Road, (from Bwandilo)\nMazengera Street, Plot number 862\nP.O Box 30081, Lilongwe 3"
  },
  {
    id: 6,
    title: "Undertake the digital user subscription study",
    company: "Farm Radio Trust (FRT)",
    location: "Lilongwe, Malawi",
    type: "Consultancy",
    subType: "Terms of Reference (TOR)",
    duration: "6 Months",
    applicationDeadline: "2025-09-10",
    postedDate: "2025-09-01",
    category: "Research & Feasibility",
    donor: "Government of Flanders",
    donorLogo: "/images/donors/flanders.jpg",
    logoa: "/images/logoa.png",
    introduction: "Farm Radio Trust (FRT) is a leading non- governmental organization dedicated exclusively to serving smallholder communities through the provision of ICT based information, communication, extension and advisory services in Malawi...",
    contentScope: "FRT deployed automation technology in the content generation and dissemination process through the development of the Malawi Agricultural Content Portal (MACoP). FRT requests expressions of interest from agri experts to undertake feasibility study to assess the user subscriptions options and what other agric content should MaCOP address to enable this platform is sustainable.",
    objectives: "The objective of the assignment is to undertake an assessment of the feasibility for user fee subscription for agric digital platforms including MaCOP.",
    keyTasks: [
      "Develop an assessment methodology based on agri platform users.",
      "Conduct assessment with digital platform users including farmers.",
      "Review the MaCOP platform and assess areas for improvement to attract user fee subscription.",
      "Make recommendations for subscription options to attract users.",
      "Compile a final assessment report with actionable recommendations for the future."
    ],
    deliverables: [
      "An inception report outlining the process for the assignment.",
      "A final user subscription report with clear recommendations"
    ],
    timeFrame: "This assignment shall be conducted in no more than 6 months period.",
    qualifications: [
      "A minimum of master’s degree in agriculture Extension and Rural Development or related discipline e.g. organization development, Monitoring and evaluation business administration, agribusiness Communication, Development Studies",
      "At least 10 years’ experience in conducting monitoring and evaluation.",
      "Understanding of the media and ICT landscape and how it relates to agricultural extension and advisory services is a must."
    ],
    applicationProcess: "Interested Consultant/s may submit an EOI electronically and CVs by 10th September 2025. For more information contact the undersigned.\n\nDirector of Programs\nFarm Radio Trust\ninfo@farmradiomw.org\n\nSubmission should be made through:\nFarm Radio Trust Offices\nArea 47 Sector 4\nOff Msokela Road, (from Bwandilo)\nMazengera Street, Plot number 862\nP.O Box 30081, Lilongwe 3"
  },
  {
    id: 7,
    title: "Undertake ICT hubs supportive and impact supervision",
    company: "Farm Radio Trust (FRT)",
    location: "Lilongwe, Malawi",
    type: "Consultancy",
    subType: "Terms of Reference (TOR)",
    duration: "4 Months",
    applicationDeadline: "2025-09-15",
    postedDate: "2025-08-05",
    category: "Monitoring & Supervision",
    donor: "Government of Flanders",
    donorLogo: "/images/donors/flanders.jpg",
    logoa: "/images/logoa.png",
    introduction: "Farm Radio Trust (FRT) is a leading non- governmental organization dedicated exclusively to serving smallholder communities through the provision of ICT based information, communication, extension and advisory services in Malawi...",
    contentScope: "Farm Radio Trust would like to upscale the uptake of ICTs to access and utilize engagement in the agriculture sector. FRT requests expressions of interest from capacity building experts to undertake supportive and impact supervision to the farming communities in the ICT hubs.",
    objectives: "The objective of the assignment is to undertake ICT hub supportive supervision to spur technology update and commercial oriented agri food systems for farming communities especially youth lead ICT hubs.",
    keyTasks: [
      "Develop s supportive supervision tool.",
      "Undertake supportive supervision to strengthen ICT hubs.",
      "Document technology adoption and access to structured markets",
      "Document linkages and synergies with other agriculture service providers",
      "Compile a final supervision report with clear recommendations for the future."
    ],
    deliverables: [
      "An inception report outlining the process for the assignment.",
      "A final supervision report with clear recommendations"
    ],
    timeFrame: "This assignment shall be conducted in no more than 4 months period.",
    qualifications: [
      "A minimum of master’s degree in agriculture Extension and Rural Development or related discipline e.g. organization development, business administration, agribusiness Communication, Development Studies",
      "At least 5 years’ experience in conducting training sessions with farmers.",
      "Understanding of the media and ICT landscape and how it relates to agricultural extension and advisory services is a must."
    ],
    applicationProcess: "Interested Consultant/s may submit an EOI electronically and CVs by 15th September 2025. For more information contact the undersigned.\n\nDirector of Programs\nFarm Radio Trust\ninfo@farmradiomw.org\n\nSubmission should be made through:\nFarm Radio Trust Offices\nArea 47 Sector 4\nOff Msokela Road, (from Bwandilo)\nMazengera Street, Plot number 862\nP.O Box 30081, Lilongwe 3"
  },
  {
    id: 8,
    title: "Develop business and investment business models/cases for win- win with private sector.",
    company: "Farm Radio Trust (FRT)",
    location: "Lilongwe, Malawi",
    type: "Consultancy",
    subType: "Terms of Reference (TOR)",
    duration: "3 Months",
    applicationDeadline: "2025-09-18",
    postedDate: "2025-08-28",
    category: "Business & Strategy",
    donor: "Government of Flanders",
    donorLogo: "/images/donors/flanders.jpg",
    logoa: "/images/logoa.png",
    introduction: "Farm Radio Trust (FRT) is a leading non- governmental organization dedicated exclusively to serving smallholder communities through the provision of ICT based information, communication, extension and advisory services in Malawi...",
    contentScope: "FRT conducted an assessment for undertaking business to business option for ICT based extension delivery. FRT requests call for the proposals to develop business models and business plans with a private sector for a win-win business intervention in agri food systems.",
    objectives: "The objective of this assignment is to develop business models and a business plan for delivering ICT-bundled services in partnership with private-sector actors within the agri-food system.",
    keyTasks: [
      "Review the current landscape of ICT interventions in agriculture and identify additional ICT solutions that could be incorporated into bundled service offerings.",
      "Review relevant private-sector actors and propose suitable business models that FRT can adopt within a bundled services approach.",
      "Develop a comprehensive business plan for ICT-bundled services, structured around win–win models for partners in the agri-food system."
    ],
    deliverables: [
      "An inception report outlining the methodology and execution plan for the assignment.",
      "Draft business models and a draft business plan for ICT-enabled bundled services in the agri-food system.",
      "Final approved business models and business plan"
    ],
    timeFrame: "This assignment shall be conducted in no more than 3 months period.",
    qualifications: [
      "A masters degree in communications, languages, Development studies, Agriculture, Community Development , agri business",
      "Understanding of local languages",
      "At least 5 years’ experience in conducting ICT related assignments in the agricultural sector."
    ],
    applicationProcess: "Interested Consultant/s may submit an EOI electronically and CVs by 18th September 2025. For more information contact the undersigned.\n\nDirector of Programs\nFarm Radio Trust\ninfo@farmradiomw.org\n\nSubmission should be made through:\nFarm Radio Trust Offices\nArea 47 Sector 4\nOff Msokela Road, (from Bwandilo)\nMazengera Street, Plot number 862\nP.O Box 30081, Lilongwe 3"
  },
  {
    id: 9,
    title: "Undertake the cohort tracking for the farming communities",
    company: "Farm Radio Trust (FRT)",
    location: "Lilongwe, Malawi",
    type: "Consultancy",
    subType: "Terms of Reference (TOR)",
    duration: "6 Months",
    applicationDeadline: "2025-09-10",
    postedDate: "2025-08-20",
    category: "Monitoring & Evaluation",
    donor: "Government of Flanders",
    donorLogo: "/images/donors/flanders.jpg",
    logoa: "/images/logoa.png",
    introduction: "Farm Radio Trust (FRT) is a leading non- governmental organization dedicated exclusively to serving smallholder communities through the provision of ICT based information, communication, extension and advisory services in Malawi...",
    contentScope: "Farm Radio Trust would like to upscale the uptake of ICTs to access and utilize engagement in the agriculture sector to improve farming households’ livelihoods. FRT requests expressions of interest from monitoring and evaluation to undertake farmer cohort tracking through ICT hubs.",
    objectives: "The objective of the assignment is to undertake cohort tracking to track impactful changes that have happened in the farming communities through sampled household tracking.",
    keyTasks: [
      "Develop a criterion for sampling a household to be part of cohort tracking.",
      "Undertake cohort tracking for household on monthly basis with focus to men, women and youth lead households.",
      "Undertake data analysis and present the update on monthly basis.",
      "Compile a final cohort tracking with clear recommendations for the future."
    ],
    deliverables: [
      "An inception report outlining the process for the assignment.",
      "Tracking monthly reports",
      "A final cohort tracking report with clear recommendations"
    ],
    timeFrame: "This assignment shall be conducted in no more than 6 months period.",
    qualifications: [
      "A minimum of master’s degree in agriculture Extension and Rural Development or related discipline e.g. organization development, Monitoring and evaluation business administration, agribusiness Communication, Development Studies",
      "At least 10 years’ experience in conducting monitoring and evaluation.",
      "Understanding of the media and ICT landscape and how it relates to agricultural extension and advisory services is a must."
    ],
    applicationProcess: "Interested Consultant/s may submit an EOI electronically and CVs by 10th September 2025. For more information contact the undersigned.\n\nDirector of Programs\nFarm Radio Trust\ninfo@farmradiomw.org\n\nSubmission should be made through:\nFarm Radio Trust Offices\nArea 47 Sector 4\nOff Msokela Road, (from Bwandilo)\nMazengera Street, Plot number 862\nP.O Box 30081, Lilongwe 3"
  },
  {
    id: 10,
    title: "Assessment of ICT innovations and development of framework for innovation center",
    company: "Farm Radio Trust (FRT)",
    location: "Lilongwe, Malawi",
    type: "Consultancy",
    subType: "Terms of Reference (TOR)",
    duration: "3 Months",
    applicationDeadline: "2025-09-25",
    postedDate: "2024-05-08",
    category: "Innovation & ICT",
    donor: "Government of Flanders",
    donorLogo: "/images/donors/flanders.jpg",
    logoa: "/images/logoa.png",
    introduction: "Farm Radio Trust (FRT) is a leading non- governmental organization dedicated exclusively to serving smallholder communities through the provision of ICT based information, communication, extension and advisory services in Malawi...",
    contentScope: "Farm Radio Trust would like to upscale the uptake of ICTs to access and utilize engagement in the agriculture sector. FRT developed Memorandum of Understanding with Malawi University of Science and Technology to spur innovation in the ICT for development. FRT requests expressions of interest from ICT experts to undertake assessment of ICT innovations and develop a framework for managing the innovation center to spur agri ICT innovations.",
    objectives: "The objective of the assignment is to undertake assessment of the ICT innovations and develop a framework that will guide ICT innovations for agri food systems.",
    keyTasks: [
      "Undertake a literature review of operations of ICT innovations.",
      "Conduct assessment of existing ICT innovations and gaps in the Agri food systems",
      "Develop a framework for nurturing the FRT ICT innovation center",
      "Develop a guide for managing the ICT innovation center"
    ],
    deliverables: [
      "An inception report outlining the process for the assignment.",
      "An assessment and framework for nurturing the ICT innovation center.",
      "Final report of the assessment, guidelines for nurturing the ICT innovation center and clear recommendations."
    ],
    timeFrame: "This assignment shall be conducted in no more than 3 months period.",
    qualifications: [
      "A bachelor’s degree in ICT, computer science, communications. Development studies",
      "A master’s degree is an advantage",
      "At least 5 years’ experience in conducting institutional assessment and development ICT innovations.",
      "Understanding of the media and ICT for development landscape."
    ],
    applicationProcess: "Interested Consultant/s may submit an EOI electronically and CVs by 25th September 2025. For more information contact the undersigned.\n\nDirector of Programs\nFarm Radio Trust\ninfo@farmradiomw.org\n\nSubmission should be made through:\nFarm Radio Trust Offices\nArea 47 Sector 4\nOff Msokela Road, (from Bwandilo)\nMazengera Street, Plot number 862\nP.O Box 30081, Lilongwe 3"
  }
];
